import { combineReducers } from 'redux';

import sharedWorkoutUiReducer from './sharedWorkoutUiReducer';
import sharedWorkoutDataReducer from './sharedWorkoutDataReducer';

export default combineReducers({
  ui: sharedWorkoutUiReducer,
  data: sharedWorkoutDataReducer,
});
